// @ts-check
export { default as LOGO_HISPATEC } from '@/static/img/logo_hispatec_erp.svg';

export const APP_VERSION = '3.1.0';
export const MIN_ERP_VERSION = '5024.24';

export const APPLICATION_NAME = 'APPErpAgro';
export const DATABASE_NAME = 'appErpAgro';

/* eslint-disable prefer-destructuring */
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_WEB = process.env.TARGET === 'web';
export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;
/* eslint-enable prefer-destructuring */

export const AUTOMATIC_UPDATE_ALERT_ERP = true;
export const AUTOMATIC_UPDATE_INTERVAL_ALERT_ERP = 60; // Seconds
export const FILTER_ALERTANOTIFICACION = [
  {
    TextoBusqueda: '',
    TipoAlertaOrigenBusqueda: 'ControlMinutosActividad',
    FechaInicioBusqueda: '2020-06-20T00:00:00.000Z',
    FechaFinBusqueda: null,
  },
];

export const GOOGLE_MAPS_API_KEY = 'AIzaSyDUfw6Y6T4LGY5F6CYAFFsjS5UwnLJBe-U';
